var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMega(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#d9272e",
    d: "M 232.5,-0.5 C 247.833,-0.5 263.167,-0.5 278.5,-0.5C 368.144,10.3879 435.644,54.7213 481,132.5C 497.695,163.971 507.861,197.304 511.5,232.5C 511.5,247.833 511.5,263.167 511.5,278.5C 500.612,368.144 456.279,435.644 378.5,481C 347.029,497.695 313.696,507.861 278.5,511.5C 263.167,511.5 247.833,511.5 232.5,511.5C 142.856,500.612 75.3562,456.279 30,378.5C 13.3053,347.029 3.1386,313.696 -0.5,278.5C -0.5,263.167 -0.5,247.833 -0.5,232.5C 10.3875,142.857 54.7208,75.3573 132.5,30C 163.971,13.3053 197.304,3.1386 232.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefdfd",
    d: "M 241.5,127.5 C 295.259,124.795 336.759,145.795 366,190.5C 392.839,242.105 388.839,291.105 354,337.5C 316.573,377.902 271.073,391.402 217.5,378C 166.316,359.475 136.482,323.308 128,269.5C 125.233,205.512 153.066,160.678 211.5,135C 221.474,131.84 231.474,129.34 241.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9282e",
    d: "M 190.5,206.5 C 196.952,206.084 203.285,206.584 209.5,208C 224.681,223.347 240.014,238.514 255.5,253.5C 270.986,238.514 286.319,223.347 301.5,208C 307.723,206.419 314.056,206.085 320.5,207C 321.662,239.095 321.829,271.262 321,303.5C 313.53,304.82 306.03,304.82 298.5,303.5C 297.667,285.176 297.167,266.842 297,248.5C 284.833,260.667 272.667,272.833 260.5,285C 257.167,287 253.833,287 250.5,285C 238.333,272.833 226.167,260.667 214,248.5C 213.667,266.5 213.333,284.5 213,302.5C 212.5,303 212,303.5 211.5,304C 204.5,304.667 197.5,304.667 190.5,304C 189.17,271.5 189.17,239 190.5,206.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMega);
export default __webpack_public_path__ + "static/media/mega.e8df3da9fb2c6e7ce70bed43d7631278.svg";
export { ForwardRef as ReactComponent };